import React__default from 'react';
import { __assign } from '../../_virtual/_tslib.js';
import { CircleLoader } from '@deal/components';
import styles from './styles.css.js';

var Loader = function Loader(props) {
  return React__default.createElement("div", {
    className: styles.loader
  }, React__default.createElement(CircleLoader, __assign({}, props)));
};

export default Loader;
//# sourceMappingURL=index.js.map
